import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { SupportOrganizationApi } from "../../../../../../../services/support/types";
import DropdownList from "./DropdownList";

interface Props {
	data: SupportOrganizationApi[];
	setSelectedSorts: (sorts: string[]) => void;
	selectedSorts: string[];
}

const OrganizationList = ({ data, setSelectedSorts, selectedSorts }: Props) => {
	const { t } = useTranslation("admin");
	const headerColumns = [
		{
			id: "name",
			title: t("lib:common.word.name"),
		},
		{
			id: "company_id",
			title: t("common.word.company_id"),
		},
		{
			id: "company_name",
			title: t("common.word.company_name"),
		},
		{
			id: "phone_number",
			title: t("lib:common.word.phone_number"),
		},
		{
			id: "tax_id_no",
			title: t("lib:common.word.tax_id_no.title"),
		},
		{
			id: "email",
			title: t("lib:common.word.email"),
		},
		{
			id: "type",
			title: t("lib:common.word.type"),
		},
		{
			id: "intercom",
			title: t("modules.support.field.intercom.title"),
		},
		{
			id: "last_activity_at",
			title: t("common.word.last_activity_at"),
		},
		{
			id: "city",
			title: t("lib:common.address.city"),
		},
		{
			id: "client_reference",
			title: t("modules.support.field.client_reference.title"),
		},
	];

	const drawNameColumn = (item: SupportOrganizationApi) => {
		if (item.type === "GOACCOUNTS")
			return (
				<Link to={`/support/organizations_with_access/${item.id}`}>
					{item.name}
					{item.parent_company && (
						<small>
							<br />
							{item.parent_company}
						</small>
					)}
				</Link>
			);
		return item.name;
	};

	const getDataColumns = (item: SupportOrganizationApi) => [
		<>{drawNameColumn(item)}</>,
		<>{item.company_id}</>,
		<>{item.company_name}</>,
		<>{item.phone_number}</>,
		<>{item.tax_id_no}</>,
		<>{item.email}</>,
		<>{item?.type}</>,
		<a key={item.id} href={item.intercom_url}>
			{item?.intercom_url}
		</a>,
		<>{FormatDate(item.last_activity_at)}</>,
		<>{item.city}</>,
		<>{item.client_reference}</>,
	];

	return (
		<div className="my-4">
			<DropdownList
				title={t("lib:common.word.locations")}
				headerColumns={headerColumns}
				dataColumns={getDataColumns}
				setSelectedSorts={setSelectedSorts}
				selectedSorts={selectedSorts}
				items={data}
			/>
		</div>
	);
};

export default OrganizationList;
